import React from "react";

import { ElementComponentProps } from "elements/types";
import { SelectElement } from "records/Element";
import SelectOnApply from "./SelectOnApply";
import SelectReactive from "./SelectReactive";
import { extractOnApplyParameters } from "elements/utils";

function SelectContainer(props: ElementComponentProps<SelectElement>) {
	const { isOnApplyPropsProvided, requiredOnApplyProps } =
		extractOnApplyParameters(props);
	return isOnApplyPropsProvided ? (
		<SelectOnApply {...props} {...requiredOnApplyProps} />
	) : (
		<SelectReactive {...props} />
	);
}

export default React.memo(SelectContainer);
